import 'swiper/css'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { ScrollSmoother } from 'gsap/ScrollSmoother'

import 'muicss/dist/css/mui.css'
import 'muicss/dist/js/mui'

import './styles/basic/global.css'
import './styles/basic/mui-overrides.css'
import './styles/basic/header.css'

import './styles/basic/typography.css'
import './styles/components/custom-animations.css'
import './styles/components/custom-buttons.css'
import './styles/components/custom-tooltip.css'
import './styles/components/custom-inputs.css'
import './styles/components/custom-steps.css'
import './styles/components/custom-clip-path.css'
import './styles/components/lightGallery.css'
import './styles/components/custom-pagination.css'

import './styles/sections/hero-slider.css'
import './styles/sections/about-section.css'
import './styles/sections/swipe-section.css'
import './styles/sections/projects-section.css'
import './styles/sections/border-grid-section.css'
import './styles/sections/faq-section.css'

import preloader from './js/common/preloader'
import funny from './js/common/funny'
import initVueApp from './vue-app'
import initMenuAnimation from './js/common/menu'
import initCursor from './js/common/slider-cursor'
import {
  isThereСlass,
  initSplitText,
  isSafari,
  batchOnScroll,
  staggerChildren,
} from './js/common/help-functions'
import headerAnimation from './js/common/header'

import homeHeroAnimations from './js/sections/home-hero'
import aboutAnimations from './js/sections/about-section'
import swipeAnimations from './js/sections/swipe-section'
import newsAnimations from './js/sections/news-section'
import instagramAnimations from './js/sections/instagram-section'
import teamAnimations from './js/sections/team-section'
import visionAnimations from './js/sections/vision-section'
import contactsAnimations from './js/sections/contacts-section'
import keyAnimations from './js/sections/key-section'
import projectsAnimations from './js/sections/projects-section'
import galleryAnimations from './js/sections/gallery-section'
import singleMap from './js/sections/map-section'
import initSimpleSlder from './js/sections/simple-slider'
import initFAQ from './js/sections/faq-section'
import initSliderParallax from './js/sections/slider-parallax-section'
import initSimpleVideo from './js/sections/simple-video'
import initSituation from './js/sections/situation-section'

import footerAnimation from './js/common/footer'
// import projectSingle from './js/pages/project-single'

gsap.registerPlugin(ScrollTrigger, ScrollSmoother)

window.addEventListener('pageshow', function (event) {
  if (event.persisted) {
    window.location.reload()
  }
})

window.addEventListener('beforeunload', function () {
  gsap.to('#preloader', {
    opacity: 1,
    duration: 0.6,
    overwrite: 'auto',
  })
})

document.addEventListener('DOMContentLoaded', () => {
  initVueApp()
  initSplitText('[split-direction]')
  initMenuAnimation()

  headerAnimation()

  // Smooth Scroll
  window.smoother = ScrollSmoother.create({
    wrapper: '#vue-root',
    content: '#smooth-content',
    smooth: 1,
    smoothTouch: false,
    effects: true,
  })

  preloader(afterPreloader)

  function afterPreloader() {
    gsap.effects.split('[split-trigger="scroll"]')
    gsap.effects.split('[split-trigger="load"]')
    gsap.effects.fade('[fade-trigger="load"]')
    gsap.effects.animateArrow('[arrow-trigger="scroll"]')
    gsap.effects.fade('[fade-trigger="scroll"]')
    if (isThereСlass('[batch-wrapp]')) batchOnScroll('[batch-wrapp]')
    if (isThereСlass('[stagger-children]')) staggerChildren('[stagger-children]')

    if (isThereСlass('[zoom-out-trigger="scroll"]'))
      gsap.effects.zoomOut('[zoom-out-trigger="scroll"]')

    if (isThereСlass('.home-hero-section')) homeHeroAnimations()
    if (isThereСlass('.about-section')) aboutAnimations()
    if (isThereСlass('.swipe-section')) swipeAnimations()

    if (isThereСlass('.news-section')) newsAnimations()
    if (isThereСlass('.instagram-section')) instagramAnimations()
    if (isThereСlass('.team-section')) teamAnimations()
    if (isThereСlass('.vision-section')) visionAnimations()
    if (isThereСlass('.contacts-section')) contactsAnimations()
    if (isThereСlass('.key-section')) keyAnimations()
    if (isThereСlass('.projects-section')) projectsAnimations()
    if (isThereСlass('.gallery-section')) galleryAnimations()
    if (isThereСlass('.single-map-section')) singleMap()
    if (isThereСlass('.simple-slider')) initSimpleSlder()
    if (isThereСlass('.faq-section')) initFAQ()
    if (isThereСlass('.slider-parallax-section')) initSliderParallax()
    if (isThereСlass('.video-section')) initSimpleVideo()
    if (isThereСlass('.situation-map-section')) initSituation()
  }

  footerAnimation()
  initCursor(document.querySelectorAll('.cursor-section'))

  if (isSafari()) {
    document.querySelector('html').classList.add('safari')
  } else {
    funny()
  }
})
